module.exports = __webpack_public_path__ + "static/media/firefox-screenshare-help.3c295c0d.png";